// extracted by mini-css-extract-plugin
export default {"container":"styles_container__51tWf","content":"styles_content__qr65o","label":"styles_label__-F2zd"};